import { createContext, useCallback, useContext, useEffect, useState } from "react";
import { api, getToken, setToken } from "./api";

const AuthCtx = createContext(null);

export function AuthProvider({ children }) {
    const [user, setUser] = useState(null);
    const [ready, setReady] = useState(false);

    useEffect(() => {
        // CRITICAL: returning from Google OAuth callback — skip the /me check.
        // GoogleCallback will exchange the session_id and establish the session.
        if (window.location.hash?.includes("session_id=")) {
            setReady(true);
            return;
        }
        const t = getToken();
        if (!t) {
            setReady(true);
            return;
        }
        api.get("/auth/me")
            .then((r) => setUser(r.data))
            .catch(() => setToken(null))
            .finally(() => setReady(true));
    }, []);

    const login = useCallback(async (email, password) => {
        const r = await api.post("/auth/login", { email, password });
        setToken(r.data.token);
        setUser(r.data.user);
        return r.data.user;
    }, []);

    const setSession = useCallback((u) => setUser(u), []);

    const logout = useCallback(() => {
        setToken(null);
        setUser(null);
    }, []);

    return (
        <AuthCtx.Provider value={{ user, ready, login, logout, setSession }}>
            {children}
        </AuthCtx.Provider>
    );
}

export const useAuth = () => useContext(AuthCtx);
